import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo } from 'react';
import { useEditingProps, useGetZ3kObject } from '../utils/unpack-props';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { MaterialBoolControl } from 'console/shared/components/fields';
import { select_elements_options } from 'console/device-settings/z3k/components/utils/z3k-selectors';
import { Z3KSettings, Z3KSettingsEditor, } from 'console/device-settings/z3k/provider/types';
import { MultipleSelectionTable, } from '../material-utils/multiple-selection-table/multiple-selection';
import { SettingContainer } from '../material-utils/settings-card/container';
import { SettingFullRow } from '../material-utils/settings-card/full-row';
import { IconsLibrary } from 'console/shared/components/fields/icon';
import { custom_tab_icons as custom_tab_icons_config } from 'console/shared/components/fields/icon/icons/tab-icons';
import { Control } from 'console/shared/components/fields/control';
import { TextInputWrapper } from 'console/shared/components/fields/text';
export const UIGroupComponent = memo(function UIGroupComponentImpl() {
    const z3k_name = 'ui_groups';
    const item = useGetZ3kObject(z3k_name);
    const id = item.id;
    const { config } = useContext(Z3KSettingsEditor);
    const { device_spec } = useContext(Z3KSettings);
    const elements_options = select_elements_options(config, device_spec);
    const nameEditingProps = useEditingProps(id, z3k_name, 'name');
    const iconEditingProps = useEditingProps(id, z3k_name, 'icon');
    const isHiddenEditiongProps = useEditingProps(id, z3k_name, 'is_hidden');
    const hideTitlesEditingProps = useEditingProps(id, z3k_name, 'hide_titles');
    const multipleSelectionTableOptions = useMemo(() => {
        return [
            {
                title: 'Элементы',
                help_id: 'ui_group_items',
                options: elements_options,
                z3k_field: 'items',
            },
        ];
    }, [item]);
    const onChange = useCallback((value) => {
        if (typeof value !== 'string') {
            iconEditingProps.onChange(value);
        }
    }, []);
    return (_jsx(ErrorBoundary, { children: _jsxs(SettingContainer, { children: [_jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", field: TextInputWrapper, help_id: "io_extensions_name", ...nameEditingProps }), _jsx(IconsLibrary, { onChange: onChange, value: iconEditingProps.value, icons: custom_tab_icons_config, customTab: true }), _jsx(MaterialBoolControl, { label: "\u0421\u043A\u0440\u044B\u0442\u044C \u0432\u043A\u043B\u0430\u0434\u043A\u0443", help_id: "ui_group_hide", ...isHiddenEditiongProps }), _jsx(MaterialBoolControl, { label: "\u0421\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u0433\u0440\u0443\u043F\u043F", help_id: "ui_group_hide_titles", ...hideTitlesEditingProps }), _jsx(SettingFullRow, { children: _jsx(MultipleSelectionTable, { elements: multipleSelectionTableOptions, z3k_name: z3k_name, notification: false, name_second_column: 'Элементы' }) })] }) }));
});
